import React from 'react';
import { TwoColumnsRecord } from 'types/dynamic-forms/records/TwoColumnsRecord';
import DynamicContentRenderer from '../DynamicContentRenderer';
import { DoubleFieldGrid } from 'styles/v2/Styles.styled';

const TwoColumnsRenderer: React.FC<TwoColumnsRecord> = ({ children }) => {
  return (
    <DoubleFieldGrid>
      <DynamicContentRenderer schema={children} />
    </DoubleFieldGrid>
  );
};

export default TwoColumnsRenderer;
